module.exports = __webpack_public_path__ + "static/img/banner.ab9e5e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = Yz7+
// module chunks = 1